import React, { useState, useCallback, useEffect } from 'react';
import { Checkbox, Form } from 'antd';
import moment from 'moment';
import {
 ConnectHeader,
 ConnectName,
 ConnectPeriod,
 Header,
 InputIndication,
 TableReading,
 Underline,
 SubmitButton,
} from '../../MeteringDevices.styled';

export default function TableMetering({
 connect,
 meterings,
 isLoading,
 form,
 isSubmiting,
}) {
 const [currentValue, setCurrentValue] = useState<number>();
 const [checked, setChecked] = useState({});
 const [value, setValue] = useState<number>();

 const onChange = (value) => {
  setChecked(value);

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true))
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 };

 useEffect(() => {
  form.resetFields();

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true))
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 }, []);

 useEffect(() => {
  sessionStorage.removeItem('meteringForm');
  form.resetFields();

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true))
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 }, [connect]);

 //  sessionStorage.setItem(
 //   'meteringForm',
 //   JSON.stringify(form.getFieldsValue(true))
 //  );

 //  const value = JSON.parse(sessionStorage.getItem('meteringForm'));

 const currentValueVolume = (e: number) => {
  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true))
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));

  setCurrentValue(e);
  createNewArr(meterings);
 };

 // const currentValueVolume = useCallback(
 //   (value) => {
 //     setCurrentValue(value);
 //   },
 //   [currentValue]
 // );

 const groupedDevices: Record<string, Models.MeteringDevices[]> =
  meterings?.reduce((result, item) => {
   if (result[item.meteringDeviceId] != null) {
    result[item.meteringDeviceId].push(item);
   } else {
    result[item.meteringDeviceId] = [item];
   }
   return result;
  }, {});

 const check =
  value &&
  value !== undefined &&
  value !== null &&
  Object.values(value) !== undefined &&
  Object.values(value) !== null &&
  Object.values(value)?.length &&
  Object.values(groupedDevices)?.every((group) => {
   if (group.length === 1) return true;
   const values = group?.map((item) => {
    const index = meterings?.indexOf(item);
    return value[`volume-${index}`];
   });
   return (
    values?.every((v) => v !== null && v !== undefined && v !== '') ||
    values?.every((v) => v === null || v === undefined || v === '' || v === 0)
   );
  });

 const createNewArr = (data) => {
  return data
   .reduce((result, item) => {
    if (result.indexOf(item.meteringDeviceId) < 0) {
     result.push(item.meteringDeviceId);
    }
    return result;
   }, [])
   .reduce((result, name) => {
    const children = data.filter((item) => item.meteringDeviceId === name);
    result = result.concat(
     children.map((item, index) => ({
      ...item,
      rowSpan: index === 0 ? children.length : 0,
     }))
    );
    return result;
   }, []);
 };

 const columns = [
  {
   title: 'Заводской номер ПУ',
   dataIndex: ['meteringDeviceNumber'],
   render(_, record) {
    return {
     children: record.meteringDeviceNumber,
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'Тип ПУ',
   dataIndex: ['meteringDeviceType'],
   render(_, record) {
    return {
     children: record.meteringDeviceType,
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'Вид ресурса',
   dataIndex: ['energyType'],
   render(_, record) {
    return {
     children: record.energyType,
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'КТТ',
   dataIndex: ['transformationRatio'],
   render(_, record) {
    return {
     children: record.transformationRatio,
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'Шкала',
   dataIndex: ['scale'],
  },
  {
   title: 'Дата предыдущих показаний',
   dataIndex: ['previousScaleReadingsDate'],
   render: (_, record) => {
    return {
     children: moment(record.previousScaleReadingsDate).format('DD.MM.YYYY'),
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'Предыдущее показание',
   dataIndex: ['previousScaleReadings'],
  },
  {
   title: 'Текущее показание',
   dataIndex: ['currentReading'],
   render: (_, record, index) => (
    <Form.Item name={`volume-${index}`} rules={[{ required: false }]}>
     <InputIndication
      size="small"
      parser={(value) => value.replace(',', '.')}
      placeholder="Введите показание"
      value={currentValue}
      onChange={(value) => {
       currentValueVolume(value);
      }}
     />
    </Form.Item>
   ),
  },
  {
   title: 'Текущий расход',
   dataIndex: ['currentConsumption'],
   render: (_, record, index) => {
    const diff =
     value && value[`volume-${index}`]
      ? value[`volume-${index}`] - record.previousScaleReadings
      : 0;
    const zero = value && value[`zero-${index}`] ? value[`zero-${index}`] : 0;
    let maxMeteringNumber: string = '';
    let transitionZero = 0;

    if (zero && value && value[`volume-${index}`]) {
     if (record.meteringDeviceSignificance) {
      for (let i = 0; i < record.meteringDeviceSignificance; i++) {
       maxMeteringNumber = maxMeteringNumber + '9';
      }
      transitionZero =
       Number(maxMeteringNumber) -
       record.previousScaleReadings +
       value[`volume-${index}`];
     }
    }
    return (
     <div>
      {!value || value === null || value[`volume-${index}`] === undefined
       ? 0
       : record.transformationRatio === null || record.transformationRatio === 0
       ? zero
         ? transitionZero.toFixed(2)
         : diff.toFixed(2)
       : zero
       ? transitionZero.toFixed(2)
       : (diff * record.transformationRatio).toFixed(2)}
     </div>
    );
   },
  },
  {
   title: 'Единица измерения',
   dataIndex: ['measureUnit'],
   render(_, record) {
    return {
     children: record.measureUnit,
     props: {
      rowSpan: record.rowSpan,
     },
    };
   },
  },
  {
   title: 'Переход через ноль',
   dataIndex: ['measureUnit'],
   render(_, record, index) {
    return (
     <Form.Item valuePropName="checked" name={`zero-${index}`}>
      <Checkbox
       value={checked}
       onChange={(value: any) => {
        onChange(value);
       }}
      />
     </Form.Item>
    );
   },
  },
 ];

 return (
  <>
   <ConnectHeader>
    <Header>
     <ConnectName>{connect?.name}</ConnectName>
     {connect?.inputPeriodStart !== null &&
     connect?.inputPeriodStop !== null ? (
      <ConnectPeriod>
       Период передачи показаний с{' '}
       {`${moment(connect?.inputPeriodStart).format('D')} по ${moment(
        connect?.inputPeriodStop
       ).format('D')} число`}
      </ConnectPeriod>
     ) : null}
    </Header>
   </ConnectHeader>
   <Underline />
   <TableReading
    rowKey={(record) => record.id}
    columns={columns}
    rowClassName={() => 'editable-row'}
    dataSource={createNewArr(meterings)}
    loading={isLoading}
    pagination={false}
   />
   <SubmitButton
    htmlType="submit"
    loading={isSubmiting}
    onClick={() => form.submit()}
    disabled={check === true ? false : true}
   >
    Передать показания
   </SubmitButton>
  </>
 );
}
